import { CLAUSE_LOCATIONS } from 'constants/_types/ClauseLocations';

export const getClauseLocationsValues = () => Object.values(CLAUSE_LOCATIONS);
